var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"type-item",style:({backgroundColor: _vm.backgroundColor, color: _vm.textColor}),on:{"click":function($event){return _vm.itemClick(_vm.item)}}},[_c('img',{attrs:{"src":_vm.item.img,"alt":""}}),_c('div',[_vm._v(_vm._s(_vm.item.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }